export default __webpack_public_path__ + "static/media/EngInvoiceReport-minimal.4bf15800.mrt";